import React from 'react'
import {
    QueryClient,
    QueryClientProvider as TanstackQueryClientProvider,
} from '@tanstack/react-query'
import { ReactQueryDevtools } from '@tanstack/react-query-devtools'

const queryClient = new QueryClient({
    defaultOptions: {
        queries: {
            refetchOnWindowFocus: true,
            refetchOnReconnect: true,
            retry: (count) => count < 2,
            staleTime: 30 * 1000,
            gcTime: 10 * 60 * 1000,
        },
        mutations: {
            retry: false,
        },
    },
})

export default function QueryClientProvider({ children }: React.PropsWithChildren) {
    return (
        <TanstackQueryClientProvider client={queryClient}>
            {children}
            <ReactQueryDevtools initialIsOpen={false} />
        </TanstackQueryClientProvider>
    )
}
